import { api } from '@/app'
import { createQueryManager, PaginationResponse } from '@codeleap/query'
import { queryClient } from '../queryClient'
import { LearnGroup } from '@/types'

const BASE_URL = 'learn/lesson-groups/'

export const groupsManager = createQueryManager<LearnGroup>({
  name: 'learn-groups',
  queryClient: queryClient.client,
  listLimit: 10,

  async listFn(limit, offset, filters) {
    const response = await api.get<PaginationResponse<LearnGroup>>(BASE_URL, {
      params: { limit, offset, ...filters },
    })

    return response.data.results
  },

  async retrieveFn(id) {
    const response = await api.get<LearnGroup>(`${BASE_URL}${id}`)
    return response.data
  },
})
